import { render, staticRenderFns } from "./add-money.vue?vue&type=template&id=b6b5b9ec&scoped=true"
import script from "./add-money.vue?vue&type=script&lang=js"
export * from "./add-money.vue?vue&type=script&lang=js"
import style0 from "./add-money.vue?vue&type=style&index=0&id=b6b5b9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5b9ec",
  null
  
)

export default component.exports